function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient);}.cls-2{fill:url(#radial-gradient-2);}.cls-3{fill:url(#radial-gradient-3);}.cls-4{fill:url(#radial-gradient-4);}.cls-5{fill:url(#radial-gradient-5);}.cls-6{fill:url(#radial-gradient-6);}.cls-7{fill:url(#radial-gradient-7);}.cls-8{fill:url(#radial-gradient-8);}.cls-9{fill:url(#radial-gradient-9);}.cls-10{fill:url(#radial-gradient-10);}.cls-11{fill:#20222e;}.cls-12{fill:#492828;stroke:#492828;}.cls-12,.cls-13{stroke-miterlimit:10;stroke-width:15px;}.cls-13{fill:#4c2828;stroke:#683737;}"), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient",
  cx: 879,
  cy: 729.16,
  r: 343.01,
  gradientTransform: "translate(0 -624.59) scale(1 1.86)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#22b573"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.05,
  stopColor: "#21b271"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#1b8f5b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#188253"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-2",
  cx: 1363,
  cy: 1103.16,
  r: 334.62,
  gradientTransform: "translate(0 -225.55) scale(1 1.2)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e53c68"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.21,
  stopColor: "#e03b66"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#d2375f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#ba3154"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#9a2845"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#992845"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-3",
  cx: 395,
  cy: 1009.66,
  r: 367.35,
  gradientTransform: "translate(0 -203.77) scale(1 1.2)",
  xlinkHref: "#radial-gradient-2"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-4",
  cx: 879,
  cy: 1357.16,
  r: 250.9,
  gradientTransform: "translate(0 908.57) scale(1 0.33)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#22a1b5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#219bad"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#1a818a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#18777d"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-5",
  cx: 88,
  cy: 760.16,
  r: 99.5,
  gradientTransform: "translate(0 -6465.75) scale(1 9.51)",
  xlinkHref: "#radial-gradient-4"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-6",
  cx: 1363,
  cy: 163.16,
  r: 177.84,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#radial-gradient-4"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-7",
  cx: 726,
  cy: 207.16,
  r: 127.1,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#radial-gradient-4"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-8",
  cx: 1363,
  cy: 506.16,
  r: 234.05,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff8033"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.21,
  stopColor: "#f67935"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#df6539"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.96,
  stopColor: "#b9443f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b54140"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-9",
  cx: 395,
  cy: 308.66,
  r: 239.47,
  xlinkHref: "#radial-gradient-8"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-10",
  cx: 879,
  cy: 1202.16,
  r: 259.31,
  gradientTransform: "translate(0 721.82) scale(1 0.4)",
  xlinkHref: "#radial-gradient-8"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Plan_copy",
  "data-name": "Plan copy"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 624,
  y: 355.16,
  width: 510,
  height: 748
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 1134,
  y: 745.16,
  width: 458,
  height: 716
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 166,
  y: 558.16,
  width: 458,
  height: 903
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 624,
  y: 1301.16,
  width: 510,
  height: 112
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  x: 10,
  y: 59.16,
  width: 156,
  height: 1402
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 1134,
  y: 59.16,
  width: 458,
  height: 208
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 624,
  y: 59.16,
  width: 204,
  height: 296
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 1134,
  y: 267.16,
  width: 458,
  height: 478
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-9",
  x: 166,
  y: 59.16,
  width: 458,
  height: 499
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 624,
  y: 1103.16,
  width: 510,
  height: 198
})), /*#__PURE__*/React.createElement("g", {
  id: "Balcoon"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-11",
  y: 51.16,
  width: 148,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-11",
  y: 1449.16,
  width: 148,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-11",
  x: 638,
  y: 1403.16,
  width: 482,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-11",
  x: -692.5,
  y: 753.66,
  width: 1405,
  height: 20,
  transform: "translate(-753.66 773.66) rotate(-90)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Wall_Packed_copy",
  "data-name": "Wall Packed copy"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-12",
  points: "1119 563.16 1119 731.16 1119 761.16 1119 1089.16 935 1089.16 935 1119.16 1119 1119.16 1119 1151.16 1149 1151.16 1149 761.16 1458 761.16 1458 731.16 1149 731.16 1149 563.16 1119 563.16"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-12",
  points: "181 574.16 204 574.16 204 544.16 181 544.16 181 261.16 151 261.16 151 544.16 151 574.16 151 1119.16 181 1119.16 181 574.16"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-12",
  points: "1577 45.16 1149 45.16 1149 44.5 1119 44.5 1119 45.16 1119 75.16 1119 253.16 1119 283.16 1119 341.16 843 341.16 843 75.16 843 45.16 813 45.16 639 45.16 609 45.16 181 45.16 151 45.16 151 75.16 151 111.16 181 111.16 181 75.16 609 75.16 609 111.16 639 111.16 639 75.16 813 75.16 813 341.16 639 341.16 639 215.16 609 215.16 609 341.16 609 371.16 609 398.16 639 398.16 639 371.16 813 371.16 843 371.16 1119 371.16 1119 448.16 1149 448.16 1149 371.16 1149 341.16 1149 283.16 1458 283.16 1458 253.16 1149 253.16 1149 75.16 1577 75.16 1577 253.16 1554 253.16 1554 283.16 1577 283.16 1577 731.16 1554 731.16 1554 761.16 1577 761.16 1577 1432.16 1149 1432.16 1149 1317.16 1149 1287.16 1149 1255.16 1119 1255.16 1119 1287.16 1084 1287.16 1084 1317.16 1119 1317.16 1119 1432.16 1119 1462.16 1149 1462.16 1607 1462.16 1607 1443.16 1607 1432.16 1607 761.16 1607 731.16 1607 283.16 1607 253.16 1607 75.16 1607 45.16 1577 45.16"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-12",
  x: 769,
  y: 1287.16,
  width: 220,
  height: 30
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-12",
  points: "639 544.16 639 517.16 609 517.16 609 544.16 300 544.16 300 574.16 609 574.16 609 1089.16 609 1119.16 609 1151.16 639 1151.16 639 1119.16 807 1119.16 807 1089.16 639 1089.16 639 574.16 639 544.16"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-12",
  points: "639 1255.16 609 1255.16 609 1287.16 609 1317.16 609 1432.16 181 1432.16 181 1271.16 151 1271.16 151 1432.16 151 1462.16 181 1462.16 609 1462.16 639 1462.16 639 1432.16 639 1317.16 674 1317.16 674 1287.16 639 1287.16 639 1255.16"
})), /*#__PURE__*/React.createElement("g", {
  id: "Wall_Packed",
  "data-name": "Wall Packed"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-13",
  points: "1119 526.16 1119 694.16 1119 724.16 1119 1052.16 935 1052.16 935 1082.16 1119 1082.16 1119 1114.16 1149 1114.16 1149 724.16 1458 724.16 1458 694.16 1149 694.16 1149 526.16 1119 526.16"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-13",
  points: "181 537.16 204 537.16 204 507.16 181 507.16 181 224.16 151 224.16 151 507.16 151 537.16 151 1082.16 181 1082.16 181 537.16"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-13",
  points: "1577 8.16 1149 8.16 1149 7.5 1119 7.5 1119 8.16 1119 38.16 1119 216.16 1119 246.16 1119 304.16 843 304.16 843 38.16 843 8.16 813 8.16 639 8.16 609 8.16 181 8.16 151 8.16 151 38.16 151 74.16 181 74.16 181 38.16 609 38.16 609 74.16 639 74.16 639 38.16 813 38.16 813 304.16 639 304.16 639 178.16 609 178.16 609 304.16 609 334.16 609 361.16 639 361.16 639 334.16 813 334.16 843 334.16 1119 334.16 1119 411.16 1149 411.16 1149 334.16 1149 304.16 1149 246.16 1458 246.16 1458 216.16 1149 216.16 1149 38.16 1577 38.16 1577 216.16 1554 216.16 1554 246.16 1577 246.16 1577 694.16 1554 694.16 1554 724.16 1577 724.16 1577 1395.16 1149 1395.16 1149 1280.16 1149 1250.16 1149 1218.16 1119 1218.16 1119 1250.16 1084 1250.16 1084 1280.16 1119 1280.16 1119 1395.16 1119 1425.16 1149 1425.16 1607 1425.16 1607 1406.16 1607 1395.16 1607 724.16 1607 694.16 1607 246.16 1607 216.16 1607 38.16 1607 8.16 1577 8.16"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-13",
  x: 769,
  y: 1250.16,
  width: 220,
  height: 30
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-13",
  points: "639 507.16 639 480.16 609 480.16 609 507.16 300 507.16 300 537.16 609 537.16 609 1052.16 609 1082.16 609 1114.16 639 1114.16 639 1082.16 807 1082.16 807 1052.16 639 1052.16 639 537.16 639 507.16"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-13",
  points: "639 1218.16 609 1218.16 609 1250.16 609 1280.16 609 1395.16 181 1395.16 181 1234.16 151 1234.16 151 1395.16 151 1425.16 181 1425.16 609 1425.16 639 1425.16 639 1395.16 639 1280.16 674 1280.16 674 1250.16 639 1250.16 639 1218.16"
})));

function SvgBackground1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1614.5 1469.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(SvgBackground1);
export default __webpack_public_path__ + "static/media/background1.b2a7bc45.svg";
export { ForwardRef as ReactComponent };